{
  "version": 1,
  "asset_id": "e667bc7f-b25d-46bc-ac65-b26054ba8f93",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/e667bc7f-b25d-46bc-ac65-b26054ba8f93/sleeve-amateur-2-220.png",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/e667bc7f-b25d-46bc-ac65-b26054ba8f93/sleeve-amateur-2-220.png",
  "original_filename": "sleeve-amateur-2-220.png",
  "size": 47053,
  "content_type": "image/png",
  "created_at": "2026-09-29T01:15:38Z"
}
